export default __webpack_public_path__ + "static/media/Marathi_cm_1.9d043720.mp3";